import * as React from 'react'
import {
    useParams,
    useHistory,
    Link,
    useRouteMatch
} from 'react-router-dom';
import {
    Table,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    ExpandableRowContent,
    ThProps,
    TableVariant,
} from '@patternfly/react-table';
import {
    ResourceItem,
    ResourceItemVariants,
    ResourceItemType
} from '@app/components/ResourceItem'
import { Namespace, Application } from '@app/SecretManager/SecretsExplorer/model/repository'

const NamespacePage: React.FunctionComponent<{ namespaces: Namespace[], root: string }> = ({ namespaces, root }) => {

    const history = useHistory();
    const { path, url } = useRouteMatch<{ path: string, url: string }>();

    const { namespace_name } = useParams<{ namespace_name: string }>();
    const namespace = namespaces.find(n => n.name == namespace_name);
    if (namespace === undefined) {
        return <h1>Error</h1>
    }

    const table_body = (applications: Application[]) => {
        return applications.map(application => {
            return <Tr>
                <Td>
                    <ResourceItem type={ResourceItemType.Application}>
                        <Link to={`${url}/${application.name}`}>{application.name}</Link>
                    </ResourceItem>
                </Td>
                <Td>{application.kind}</Td>
                <Td>{application.containers.length}</Td>
            </Tr>
        })
    }

    return (
        <>
            <section className="dx-page-section">
                <nav className="dx-breadcrumb">
                    <span className="dx-breadcrumb__item"><Link className="dx-breadcrumb__link" to={`${root}`}>Secret Manager</Link></span>
                    <span className="dx-breadcrumb__item">Environment detail</span>
                </nav>
                <ResourceItem variant={ResourceItemVariants.h1} type={ResourceItemType.Environment}>{namespace_name}</ResourceItem>
            </section>
            <hr className="dx-divider" />
            <section className="dx-page-section">
                <h3 className="dx-title">Applications</h3>
                <Table variant={TableVariant.compact}>
                    <Thead>
                        <Tr>
                            <Th>Name</Th>
                            <Th>Kind</Th>
                            <Th>Containers</Th>
                        </Tr>
                    </Thead>
                    <Tbody>{table_body(namespace.applications)}</Tbody>
                </Table>
            </section>

        </>
    )
}

export { NamespacePage }